import { useCreateFieldGetter, useFieldBorder } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for PageNavigationRow component customisation
 * Returns navigation link configuration and styling for a specific link section
 * @param sectionKey - The section key for the specific link (e.g., HOME_SECTION_KEYS.LINK_1)
 */
export const usePageNavigationCustomisation = (sectionKey: string) => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey,
    blockKey: PUI.HOME_BLOCK_KEYS.PAGE_LINKS,
  });

  const actionType = getField(PUI.COMMON_FIELD_KEYS.ACTION_TYPE);
  const labelText = getField(PUI.COMMON_FIELD_KEYS.LABEL_TEXT);
  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const actionColor = getField(PUI.COMMON_FIELD_KEYS.ACTION_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    actionType,
    labelText,
    labelColor,
    actionColor,
    backgroundColor,
    borderColor,
  };
};
